export default "__VITE_ASSET__cf39321f__"